export const SESSION_ENDED_MESSAGE =
  "Your session has ended. Sign in again to continue.";

/** AuthGate owns recovery; individual requests must not retry or notify. */
export class SessionEndedError extends Error {
  public constructor() {
    super(SESSION_ENDED_MESSAGE);
    this.name = "SessionEndedError";
  }
}
